import React from 'react';
import { Home, Target, Settings, FileText } from 'react-feather';
import './BottomNavigation.css';

interface BottomNavigationProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
  isVisible: boolean;
}

export const BottomNavigation: React.FC<BottomNavigationProps> = ({ 
  activeTab, 
  onTabChange, 
  isVisible 
}) => {
  if (!isVisible) return null;

  return (
    <nav className="bottom-navigation">
      <button 
        className={`nav-tab ${activeTab === 'home' ? 'active' : ''}`}
        onClick={() => onTabChange('home')}
      >
        <Home size={20} />
        <span>Home</span>
      </button>
      
      <button 
        className={`nav-tab ${activeTab === 'zones' ? 'active' : ''}`}
        onClick={() => onTabChange('zones')}
      >
        <Target size={20} />
        <span>Zones</span>
      </button>
      
      <button 
        className={`nav-tab ${activeTab === 'requests' ? 'active' : ''}`}
        onClick={() => onTabChange('requests')}
      >
        <FileText size={20} />
        <span>Requests</span>
      </button>
      
      <button 
        className={`nav-tab ${activeTab === 'settings' ? 'active' : ''}`}
        onClick={() => onTabChange('settings')}
      >
        <Settings size={20} />
        <span>Settings</span>
      </button>
    </nav>
  );
}; 